import { CourseStatus, type CourseSkillLevel } from "@/lib/constants";
import { handleSupabaseList, supabase } from "@/lib/supabase-unified";
import type { Course } from "@/types";

export type CourseCatalogSearchRow = {
  id: number;
  title: string;
  slug: string;
  thumbnail: string | null;
  summary: string | null;
  rank: number;
  skill_level: CourseSkillLevel | null;
  user_progress: number | null;
  instruments: string[] | null;
  instructor_names: string[] | null;
  avatar_url_mobile: string | null;
  avatar_url_desktop: string | null;
  desktop_banner_url: string | null;
  mobile_banner_url: string | null;
};

/** Upper bound for browse mode (empty query) — covers the full catalog. */
export const COURSE_CATALOG_BROWSE_LIMIT = 500;

/** Hydrate a catalog search row into the Course shape the hub cards/filters use. */
export function catalogRowToCourse(row: CourseCatalogSearchRow): Course {
  return {
    id: row.id,
    title: row.title,
    slug: row.slug,
    thumbnail: row.thumbnail,
    summary: row.summary,
    skill_level: row.skill_level,
    instruments: row.instruments,
    instructor_names: row.instructor_names,
    avatar_url_mobile: row.avatar_url_mobile,
    avatar_url_desktop: row.avatar_url_desktop,
    desktop_banner_url: row.desktop_banner_url ?? undefined,
    mobile_banner_url: row.mobile_banner_url ?? undefined,
  };
}

export async function searchCourseCatalog(
  rawQuery: string,
  limit: number = 100,
  userId?: string | null,
  skillLevels?: CourseSkillLevel[] | null,
  minStatus: number = CourseStatus.Published,
): Promise<CourseCatalogSearchRow[]> {
  const levels =
    skillLevels?.length && skillLevels.length > 0 ? skillLevels : null;

  return handleSupabaseList<CourseCatalogSearchRow>(
    supabase.rpc("course_catalog_search_v4", {
      search_term: rawQuery.trim(),
      p_limit: limit,
      p_user_id: userId ?? null,
      p_skill_levels: levels,
      p_min_status_course: minStatus,
    }) as never,
  );
}
